import { render, staticRenderFns } from "./CooperativePriceList.vue?vue&type=template&id=54c1ea31&scoped=true&"
import script from "./CooperativePriceList.vue?vue&type=script&lang=js&"
export * from "./CooperativePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1ea31",
  null
  
)

export default component.exports